import Vue from 'vue'
import Router from 'vue-router'
import { getCookie, isWeiXin } from '../util/util'
const Home = () =>
    import(/* webpackChunkName: "Home" */ '../pages/Home/Home.vue')
const HomeNew = () =>
    import(/* webpackChunkName: "HomeNew" */ '../pages/HomeNew/HomeNew.vue')
const Login = () =>
    import(/* webpackChunkName: "Login" */ '../pages/Login/Login.vue')
// 填身份证（使用人）IdCard
const IdCard = () =>
    import(
    /* webpackChunkName: "IdCard" */ '../pages/IdCard/IdCard.vue'
    )
const Build = () =>
    import(
    /* webpackChunkName: "Build" */ '../pages/Build/Build.vue'
    )
const BuildSx = () =>
import(
/* webpackChunkName: "BuildSx" */ '../pages/BuildSx/BuildSx.vue'
)
const BindActivate = () =>
    import(
    /* webpackChunkName: "BindActivate" */ '../pages/BindActivate/BindActivate.vue'
    )
const BindBook= () =>
    import(
    /* webpackChunkName: "BindBook" */ '../pages/BindBook/BindBook.vue'
    )
const BindHome = () =>
    import(
    /* webpackChunkName: "BindHome" */ '../pages/BindHome/BindHome.vue'
    )
const YdBook = () =>
    import(
    /* webpackChunkName: "YdBook" */ '../pages/YdBook/YdBook.vue'
    )
const SxBook = () =>
    import(
    /* webpackChunkName: "SxBook" */ '../pages/SxBook/SxBook.vue'
    )
const Notice = () =>
    import(
    /* webpackChunkName: "Notice" */ '../pages/Notice/Notice.vue'
    )

const HtNotice = () =>
    import(
    /* webpackChunkName: "HtNotice" */ '../pages/HtNotice/HtNotice.vue'
    )

const RtNotice = () =>
    import(
    /* webpackChunkName: "RtNotice" */ '../pages/RtNotice/RtNotice.vue'
    )
const BdxNotice = () =>
    import(
    /* webpackChunkName: "BdxNotice" */ '../pages/BdxNotice/BdxNotice.vue'
    )
const Share = () =>
    import(
    /* webpackChunkName: "Share" */ '../pages/Share/Share.vue'
    )
const Book = () =>
    import(
    /* webpackChunkName: "Book" */ '../pages/Book/Book.vue'
    )
const YrBook = () =>
    import(
    /* webpackChunkName: "YrBook" */ '../pages/YrBook/YrBook.vue'
    )
const RtBook = () =>
    import(
    /* webpackChunkName: "RtBook" */ '../pages/RtBook/RtBook.vue'
    )
const BdxBook = () =>
import(
/* webpackChunkName: "BdxBook" */ '../pages/BdxBook/BdxBook.vue'
)
const HtBook = () =>
    import(
    /* webpackChunkName: "HtBook" */ '../pages/HtBook/HtBook.vue'
    )
const PiccBook = () =>
    import(
    /* webpackChunkName: "PiccBook" */ '../pages/PiccBook/PiccBook.vue'
    )
Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/homeOld',
            name: 'Home',
            component: Home,
            meta: {
                fullScreen: true,
                keepAlive: true
            }
        },
        {
            path: '/home',
            name: 'HomeNew',
            component: HomeNew,
            meta: {
                fullScreen: true,
                keepAlive: true
            }
        },
        {
            path: '/share',
            name: 'Share',
            component: Share,
            meta: {
                fullScreen: true,
                keepAlive: true
            }
        },
        {
            path: '/book',
            name: 'Book',
            component: Book,
            meta: {
                fullScreen: true,
                keepAlive: true
            }
        },
        {
            path: '/build',
            name: 'Build',
            component: Build,
            meta: {
                fullScreen: true,
                keepAlive: true
            }
        },
        {
            path: '/buildSx',
            name: 'BuildSx',
            component: BuildSx,
            meta: {
                fullScreen: true,
                keepAlive: true
            }
        },
        {
            path: '/activate',
            name: 'BindActivate',
            component: BindActivate,
            meta: {
                fullScreen: true,
                keepAlive: true
            }
        },
        {
            path: '/bindBook',
            name: 'BindBook',
            component: BindBook,
            meta: {
                fullScreen: true,
                keepAlive: true
            }
        },
        {
            path: '/bindHome',
            name: 'BindHome',
            component: BindHome,
            meta: {
                fullScreen: true,
                keepAlive: true
            }
        },
        {
            path: '/ydBook',
            name: 'YdBook',
            component: YdBook,
            meta: {
                fullScreen: true,
                keepAlive: true
            }
        },
        {
            path: '/yrBook',
            name: 'YrBook',
            component: YrBook,
            meta: {
                fullScreen: true,
                keepAlive: true
            }
        },
        {
            path: '/htBook',
            name: 'HtBook',
            component: HtBook,
            meta: {
                fullScreen: true,
                keepAlive: true
            }
        },
        {
            path: '/piccBook',
            name: 'PiccBook',
            component: PiccBook,
            meta: {
                fullScreen: true,
                keepAlive: true
            }
        },
        {
            path: '/rtBook',
            name: 'RtBook',
            component: RtBook,
            meta: {
                fullScreen: true,
                keepAlive: true
            }
        },
        {
            path: '/bdxBook',
            name: 'BdxBook',
            component: BdxBook,
            meta: {
                fullScreen: true,
                keepAlive: true
            }
        },
        {
            path: '/sxBook',
            name: 'SXBook',
            component: SxBook,
            meta: {
                fullScreen: true,
                keepAlive: true
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                fullScreen: true,
                keepAlive: false
            }
        },
        {
            path: '/idCard',
            name: 'IdCard',
            component: IdCard,
            meta: {
                fullScreen: true,
                keepAlive: false
            }
        },
        {
            path: '/notice',
            name: 'Notice',
            component: Notice,
            meta: {
                fullScreen: true,
                keepAlive: false
            }
        },
        {
            path: '/htNotice',
            name: 'HtNotice',
            component: HtNotice,
            meta: {
                fullScreen: true,
                keepAlive: false
            }
        },
        {
            path: '/rtNotice',
            name: 'RtNotice',
            component: RtNotice,
            meta: {
                fullScreen: true,
                keepAlive: false
            }
        },
        {
            path: '/bdxNotice',
            name: 'BdxNotice',
            component: BdxNotice,
            meta: {
                fullScreen: true,
                keepAlive: false
            }
        },
        { path: '*', redirect: '/home' }
    ],
    scrollBehavior(to, from, savedPosition) {
        // return {
        //   x: 0,
        //   y: 0
        // }
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ x: 0, y: 0 })
            }, 300)
        })
    }
})
router.beforeEach((to, from, next) => {
    console.log('to, from', to, from)
    // if (!getCookie('token') && !getCookie('userId') && to.name != 'WeixinLogin' && to.name != 'Login' && isWeiXin()) {
    //     next('/weixinLogin')
    // if (!getCookie('token') && !getCookie('userId')  && isWeiXin()) {
    //     console.log('1111')
    //     if(to.name == 'WeixinClkjLogin'){
    //         next('/weixinClkjLogin')
    //     }else if (to.name == 'LoginClkj'){
    //         next('/weixinClkjLogin')
    //     }else if(to.name == 'WeixinLogin'){
    //         next('/weixinLogin')
    //     } else if (to.name == 'Login'){
    //         next('/weixinLogin')
    //     } else {
    //         next('/weixinLogin')
    //     }
    // } else {
    //     console.log('2222')
    //     next()
    // }
    next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js